import {Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";

const useStyles = makeStyles(theme => ({
    choice: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "x-small"
    },
    container: {
        display: "flex",
        flexDirection: "column",
        minWidth: 120,
        borderStyle: "solid",
        borderWidth: 1,
        margin: theme.spacing(1),
        padding: theme.spacing(1)
    },
    name: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "x-small"
    },
    select: {
        fontSize: "x-small"
    }
}));

interface Props {
    choice: string
    name: string
    onChoice: (state: string, choice: string) => any
    state: string
    triggers: string[],
}
export function State({choice, name, onChoice, state, triggers}: Props) {
    const classes = useStyles();
    const handleChoiceChange = ({target}: SelectChangeEvent) => {
        onChoice(state, target.value as string);
    };

    return (
        <Box className={classes.container}>
            <Typography className={classes.name} variant="body2">{name}</Typography>
            {triggers.length > 1 &&
                <FormControl fullWidth>
                    <Select classes={{select: classes.select}} value={choice} onChange={handleChoiceChange}>
                        {triggers.map((trigger, index) => (
                            <MenuItem key={trigger} value={trigger}>{trigger}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </Box>
    );
}